<div
  [proffeoSpinner]="activeCompanyProjects() === undefined"
  proffeoSpinnerSize="lg"
  class="min-h-48 w-full"
>
  @if (activeCompanyProjects()?.length === 0) {
    <div class="flex w-full items-center justify-center p-4">
      <p>{{ 'placeholders.no-results-found' | translate }}</p>
    </div>
  } @else if (activeCompanyProjects(); as projects) {
    @for (project of projects; track project?.id) {
      <proffeo-company-project-item
        (setActiveProject)="setActiveProject($event)"
        (archiveProject)="archiveProject($event)"
        (editProject)="openEditCompanyProjectDialog($event)"
        (exportTaskImportTemplate)="onExportTaskImportTemplate($event)"
        [project]="project"
        [isSelectedProject]="project?.id === activeProjectId()"
        [isActiveProject]="true"
      ></proffeo-company-project-item>
    }
  }
</div>

<proffeo-ui-button
  (clicked)="openCreateCompanyProjectDialog()"
  variant="accent"
  fontIcon="add"
  class="fixed bottom-5 right-5 lg:bottom-10 lg:right-10"
></proffeo-ui-button>
